import { BalancePortalPage } from 'src/components/selfService/common/Balance/balance.types';

export const buildBalancePortalUrl = (
  baseUrl: string,
  page: BalancePortalPage
): string => {
  const url = new URL(baseUrl);
  url.pathname = `/${page}`;

  return url.toString();
};
